import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback, useMemo } from 'react';
import { useFlag } from '@carnica/utils/hooks';
import { IconFileFillFilled, IconImageBoxFilled } from '@carnica/graphics';
import { ymPushClickAttach, ymPushClickAttachInput, ymPushSendAttach } from "../../../../../shared/analytics";
import { useAppSelector } from "../../../../../shared/model";
import { AttachLabel } from "../../../../../shared/config";
import { selectChatCofig } from "../../../../../entities/settings/model";
import { useNotificationContext } from "../../../../../entities/notification/model";
import { getAcceptFile } from "../../utils";
export var useAttachment = function useAttachment(_ref) {
  var imageRef = _ref.imageRef,
    fileRef = _ref.fileRef,
    acceptImage = _ref.acceptImage,
    acceptFile = _ref.acceptFile,
    onImageChange = _ref.onImageChange,
    handleFileLoad = _ref.handleFileLoad;
  var _useFlag = useFlag(),
    _useFlag2 = _slicedToArray(_useFlag, 2),
    isOpen = _useFlag2[0],
    setIsOpen = _useFlag2[1];
  var _useNotificationConte = useNotificationContext(),
    addNotification = _useNotificationConte.addNotification;
  var _useAppSelector = useAppSelector(selectChatCofig),
    zoneType = _useAppSelector.authZoneConfig.zoneType;
  var handleAttachClick = function handleAttachClick() {
    if (!isOpen) {
      ymPushClickAttach(zoneType);
    }
    setIsOpen.toggle();
  };
  var handleClick = function handleClick(label, element) {
    if (!element) {
      return;
    }
    ymPushClickAttachInput(label, zoneType);
    // Очищаем значение, чтобы корректно работала нотификация
    element.value = '';
    element === null || element === void 0 || element.click();
  };
  var items = useMemo(function () {
    return [{
      label: AttachLabel.IMAGE,
      icon: IconImageBoxFilled,
      onClick: function onClick() {
        return handleClick(AttachLabel.IMAGE, imageRef.current);
      }
    }, {
      label: AttachLabel.FIlE,
      icon: IconFileFillFilled,
      onClick: function onClick() {
        return handleClick(AttachLabel.FIlE, fileRef.current);
      }
    }];
  }, []);
  var handleImageChange = useCallback(function () {
    var isAcceptImage = getAcceptFile(imageRef, acceptImage);
    setIsOpen.off();
    // Дополнительная проверка расширения файлов для Windows и мобильных устройств
    if (isAcceptImage) {
      onImageChange();
    } else {
      addNotification({
        key: 'wrongFormat',
        label: 'Тип файла не подходит',
        subTitle: 'попробуйте загрузить другой',
        view: 'error'
      });
    }
  }, []);
  var handleFileChange = useCallback(function () {
    var isAcceptFile = getAcceptFile(fileRef, acceptFile);
    setIsOpen.off();
    // Дополнительная проверка расширения файлов для мобильных устройств
    if (isAcceptFile) {
      handleFileLoad();
      ymPushSendAttach(AttachLabel.FIlE, zoneType);
    } else {
      if (!fileRef.current) return;
      fileRef.current.value = '';
      addNotification({
        key: 'wrongFormat',
        label: 'Тип файла не подходит',
        subTitle: 'попробуйте загрузить другой',
        view: 'error'
      });
    }
  }, []);
  var handleClickOutside = function handleClickOutside() {
    setIsOpen.off();
  };
  return {
    items: items,
    isOpen: isOpen,
    handleImageChange: handleImageChange,
    handleFileChange: handleFileChange,
    handleAttachClick: handleAttachClick,
    handleClickOutside: handleClickOutside
  };
};